
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"36","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('rect',{attrs:{"width":"36","height":"24","fill":"#2A2A6C","rx":"4"}}),_c('path',{attrs:{"fill":"#FFF","d":"M17.895 8.543l-1.5 6.937h-1.8l1.5-6.938h1.8zm7.545 4.5l.945-2.603.547 2.603H25.44zm2.002 2.46h1.666l-1.456-6.938h-1.5a.818.818 0 00-.75.51l-2.692 6.428h1.89l.367-1.036h2.258l.217 1.035zm-4.68-2.25c.008-1.868-2.512-2.003-2.512-2.753 0-.248.24-.51.75-.578a3.363 3.363 0 011.77.308l.315-1.5a4.842 4.842 0 00-1.68-.308c-1.77 0-3 .945-3 2.295 0 .998.892 1.553 1.567 1.883.675.33.938.563.93.863 0 .465-.555.675-1.072.682a3.758 3.758 0 01-1.83-.45l-.323 1.5a5.362 5.362 0 001.995.367c1.883 0 3.12-.93 3.128-2.37M15.367 8.52l-2.91 6.938H10.5L9.068 9.915a.75.75 0 00-.428-.607 7.327 7.327 0 00-1.77-.585l.045-.203h3.052a.839.839 0 01.833.705l.75 4.013 1.867-4.718h1.95z"}})])])
          )
        }
      }
    